import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import sharedMessages from "../../../../shared-messages";
import { getAccountDisplayName } from "../../../store/personal-user";

import "./current-account-info.scss";

const block = "current-account-info";

const CurrentAccountInfo = () => {
  const username = useSelector(getAccountDisplayName);
  return (
    <p className={block}>
      <FormattedMessage
        {...sharedMessages.currentlySignedInAs}
        values={{
          username,
          styledUsername: displayStyledUserName(block)
        }}
      />
    </p>
  );
};

const displayStyledUserName = block => msg => (
  <span className={`${block}__username`}>{msg}</span>
);

export default CurrentAccountInfo;
